import css from 'styled-jsx/css';

export default css`h2 {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.42;
  letter-spacing: .4px;
  text-align: center;
  color: #414141;
  margin-bottom: 64px;
  position: relative;
  margin-top: 160px; }
  h2::after {
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    top: 50px;
    transform: translateX(-50%);
    width: 48px;
    height: 8px;
    background-color: #414141;
    border-radius: 4px; }
`